import { render, staticRenderFns } from "./WhatsAppMessageText.vue?vue&type=template&id=3047e633&scoped=true"
import script from "./WhatsAppMessageText.vue?vue&type=script&lang=js"
export * from "./WhatsAppMessageText.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppMessageText.vue?vue&type=style&index=0&id=3047e633&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3047e633",
  null
  
)

export default component.exports